import listQueryParamsFormatter from 'elements/input/listQueryParamsFormatter'

export const parseStringifiedListFilterValue = <T>({ filterValues, key }: { filterValues; key: string }) => {
  return filterValues[key] ? (listQueryParamsFormatter.parse(filterValues[key]) as Set<T>) : new Set<T>()
}
